import { render, staticRenderFns } from "./FormRegistration.vue?vue&type=template&id=3331f2fe"
import script from "./FormRegistration.vue?vue&type=script&lang=js"
export * from "./FormRegistration.vue?vue&type=script&lang=js"
import style0 from "./FormRegistration.vue?vue&type=style&index=0&id=3331f2fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports